import _ from "lodash";
import React, { useContext, useState } from "react";
import { Alert, Button, Col, Input, Modal, ModalBody, ModalHeader, Row, Table } from "reactstrap";
import { api, helpers, UserContext } from "../utils";

export default function POAddContainerModal({
   poNumber,
   itemNumber,
   containers,
   toggleCallback,
   callbackRefresh,
}) {
   const userCtx = useContext(UserContext);
   const { currentUser } = userCtx;
   const [message, setMessage] = useState();
   const [newContainer, setNewContainer] = useState("");
   const [working, setWorking] = useState(false);

   function onDelete() {
      setWorking(true);

      // escape the forward slash character or pound symbol if in the item so it won't mess up the URL
      // Example = MP.11/64S40007 this causes the url to look like it has an extra parameter because
      // of the / character so the URL is broken and a Not Found error is thrown.
      var encodedItem = itemNumber.replace(/\//g, '%2F').replace(/#/g, '%23');
      api
         .post(`Purchasing/DeleteContainer/${poNumber}/${encodedItem}`)
         .then((r) => {
            if (r.data.success) {
               callbackRefresh();
            } else {
               setMessage(r.data.message);
            }
         })
         .catch(api.catchHandler)
         .finally(() => {
            setWorking(false);
            //callbackRefresh();
         });
   }

   function onSave() {
      if (newContainer === undefined || newContainer === null || newContainer === "")
         return;

      setWorking(true);
      const payload = {
         poNumber: poNumber,
         itemNumber: itemNumber,
         container: newContainer,
      };
      api
         .post("Purchasing/AddContainer", payload)
         .then((r) => {
            if (r.data.success) {
               callbackRefresh();
            } else {
               setMessage(r.data.message);
            }
         })
         .catch(api.catchHandler)
         .finally(() => {
            setWorking(false);
            //callbackRefresh();
         });
   }

   return (
      <Modal isOpen={true} toggle={toggleCallback}>
         <ModalHeader toggle={toggleCallback}>
            <span>Add a Container</span>
         </ModalHeader>
         <ModalBody>
            <Table striped>
               <tbody>
                  <tr>
                     <td>PO Number: {poNumber}</td>
                  </tr>
                  <tr>
                     <td>Item Number: {itemNumber}</td>
                  </tr>
                  <tr>
                     {!containers ?
                        (<td>No Assigned Container</td>)
                        : (<td>Assigned Container: {containers}</td>)}
                  </tr>
                  {!containers || (containers && currentUser?.isAdmin) ? (
                     <tr>
                        <td>
                           {!newContainer?.length ? helpers.requiredStar() : null}
                           Container:
                           <Input
                              value={newContainer}
                              onChange={(e) => setNewContainer(e.target.value)}
                           />
                        </td>
                     </tr>
                  ) : (
                     <tr>
                        <td className="text-red">A container has already been assigned and a new one cannot be added.<br /><br />Only an admin can edit this container.</td>
                     </tr>
                  )}
                  {containers && currentUser?.isAdmin && (
                     <tr>
                        <td className="text-red">ADMIN: A container has already been assigned. Saving a new container will replace the old container across all items on the PO. Deleting the container will only delete the container for this specific item on the PO.<br /><br />Please make sure this is what you want before choosing to save.</td>
                     </tr>
                  )}
               </tbody>
            </Table>
            {/* No Container exists yet */}
            {!containers && 
               <Row>
                  <Col xs={6} className="text-center">
                     <Button
                        className="shredButton w-100"
                        onClick={onSave}
                        disabled={working}
                     >
                        Save
                     </Button>
                  </Col>
                  <Col xs={6} className="text-center">
                     <Button
                        className="shredButton w-100"
                        onClick={toggleCallback}
                        disabled={working}
                     >
                        Cancel
                     </Button>
                  </Col>
               </Row>
            }
            {/* A Container exists, but user is not an admin. */}
            {containers && !currentUser?.isAdmin &&
               <Row>
                  <Col xs={6} className="text-center">
                  </Col>
                  <Col xs={6} className="text-center">
                     <Button
                        className="shredButton w-100"
                        onClick={toggleCallback}
                        disabled={working}
                     >
                        Cancel
                     </Button>
                  </Col>
               </Row>
            }
            {/* A Container exists, and admins can edit or delete. */}
            {containers && currentUser?.isAdmin &&
               <Row>
                  <Col xs={4} className="text-center">
                     {(!containers || currentUser?.isAdmin) && (
                        <Button
                           className="shredButton w-100"
                           onClick={onSave}
                           disabled={working}
                        >
                           Save
                        </Button>
                     )}
                  </Col>
                  <Col xs={4} className="text-center">
                     <Button
                        className="shredButton w-100"
                        onClick={onDelete}
                        disabled={working}
                     >
                        Delete
                     </Button>
                  </Col>
                  <Col xs={4} className="text-center">
                     <Button
                        className="shredButton w-100"
                        onClick={toggleCallback}
                        disabled={working}
                     >
                        Cancel
                     </Button>
                  </Col>
               </Row>
            }
            {!_.isNil(message) && message.length > 0 && (
               <Row className="mt-3 mb-0 pb-0">
                  <Col>
                     <Alert color="danger">{message}</Alert>
                  </Col>
               </Row>
            )}
         </ModalBody>
      </Modal>
   );
}
